import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Amplify, Auth } from "aws-amplify";

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));

// Get the current URL without parameters
const currentUrl = window.location.href.split('?')[0];

Amplify.configure({
	Auth: {
		region: 'ap-southeast-2',
		userPoolId: 'ap-southeast-2_SFzExzK0C',
		userPoolWebClientId: '2dihrehvtj0il7gr3vkiilvb72',
		//authenticationFlowType: 'USER_PASSWORD_AUTH',
		mandatorySignIn: false,
		oauth: {
			domain: 'frametoday-online.auth.ap-southeast-2.amazoncognito.com',
			scope: ['email', 'profile', 'openid'],
			redirectSignIn: currentUrl,
			redirectSignOut: currentUrl,
			responseType: 'code'
		}
	}
});

console.log(currentUrl);
